import { createReducer } from '@reduxjs/toolkit';
import { changeUserPassword, getHistory } from '../actions/userAccount';

const initialState = {
  loading: true,
  history: [],
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getHistory.fulfilled, (state, action) => ({
    ...state,
    history: action.payload.allHistory || [],
    loading: false,
  })).addCase(changeUserPassword.fulfilled, () => {

  }).addCase(getHistory.pending, (state) => ({
    ...state,
    loading: true,
  })).addCase(getHistory.rejected, (state) => ({
    ...state,
    loading: false,
    history: [],
  }));
});
